<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.ADD') }} {{ $t('RELATED_PERSONS.ITEM') }}</span
      >
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('cancel')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field :label="`${name}`" disabled></v-text-field>

        <v-container grid-list-xl>
          <v-layout wrap>
            <v-flex xs12 md8>
              <persons-autocomplete
                v-model="form.related_id"
                item-value="id"
                item-text="inline"
                :default-search="defaultSearch"
                :loading="loading"
                :rules="rules.requiredSelectNotArray"
                :label="`${$t('RELATED_PERSONS.ITEM')} *`"
                :error-messages="errors.related_id"
                @input="updateValue('related_id', $event)"
              />
            </v-flex>

            <v-flex xs12 md4>
              <v-btn @click="dialogCreateNewPerson = !dialogCreateNewPerson">
                <v-icon class="mr-1" small>mdi-plus</v-icon>
                {{ $t('PERSONS.NEW_PERSON') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>

        <v-autocomplete
          v-model="form.relationship_id"
          :items="relationships"
          :loading="!!!relationships"
          item-value="id"
          item-text="name"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.RELATIONSHIP')} *`"
          :error-messages="errors.relationship_id"
          @input="updateValue('relationship_id', $event)"
        ></v-autocomplete>

        <v-switch v-model="form.key" :label="$t('RELATIONS.KEY')"></v-switch>

        <v-textarea
          v-model="form.notes"
          outlined
          counter="80"
          :rules="rules.textDescription80"
          :label="$t('RELATIONS.NOTES')"
          :error-messages="errors.notes"
          @input="updateValue('notes', $event)"
        ></v-textarea>

        <v-autocomplete
          v-model="form.priority"
          :items="prioritiesList"
          item-text="title"
          item-value="id"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.PRIORITY')} *`"
          :error-messages="errors.priority"
          @input="updateValue('priority', $event)"
        ></v-autocomplete>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>
            <v-btn color="success" :disabled="!valid" @click="validate">
              {{ $t('BUTTON.SAVE') }}
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <v-dialog
      v-if="dialogCreateNewPerson"
      v-model="dialogCreateNewPerson"
      persistent
      max-width="800px"
    >
      <create-new-person
        @cancel="dialogCreateNewPerson = !dialogCreateNewPerson"
        @success="createdNewRelatedPerson"
      ></create-new-person>
    </v-dialog>
  </v-card>
</template>

<script>
import CreateNewPerson from './CreateNewPerson';
import {
  requiredSelectNotArray,
  textDescription80
} from '@/modules/_global/variables/rules.js';
import priority from '@/modules/relations/components/mixins/priority';
import formEditable from '@/modules/_global/mixins/form-editable';
import PersonsAutocomplete from '@/components/relations/PersonsAutocomplete';
import { mapState } from 'vuex';

export default {
  name: 'RelationsPersonCreate',

  components: {
    PersonsAutocomplete,
    CreateNewPerson
  },

  mixins: [priority, formEditable],

  props: {
    name: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    form: {
      key: false
    },
    error: null,
    valid: true,
    relationships: [],
    defaultSearch: null,
    dialogCreateNewPerson: false,
    persons: [],
    rules: { requiredSelectNotArray, textDescription80 }
  }),

  computed: {
    ...mapState(['loading'])
  },

  created() {
    this.$store
      .dispatch('relation/retrieveRelationshipsWithPerson')
      .then(response => {
        this.relationships = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$emit('create', {
          ...this.form
        });
      }
    },

    createdNewRelatedPerson(person) {
      this.form.related_id = person.id;
      this.defaultSearch = person.first_name;
      this.dialogCreateNewPerson = !this.dialogCreateNewPerson;
    }
  }
};
</script>
